// CustomerSelectionModal.js
import React, { useState, useEffect, useContext, useRef } from 'react';
import 'datatables.net-bs5';
import $ from 'jquery';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
function SupplierSelectionModal({ show, onClose, suppliers, onSelectSupplier }) {
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const tableRef = useRef();
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }


        $(tableRef.current).DataTable({
            dom: '<"row"<"col-sm-6 d-flex align-items-center"Bf><"col-sm-6 d-flex justify-content-end"p>>rt',
            pagingType: 'full_numbers',
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search..."
            },

            lengthChange: false,
            initComplete: function () {

                $('.btn-dataTable').css('background', 'none');
                $('.btn-dataTable').css('border', 'none');
                $('.btn-dataTable').removeClass('btn-secondary');
                $('.btn-dataTable').removeClass('btn');
                $('.btn-dataTable').removeClass('btn-dataTable');
                //  $('.dt-search input[type="search"]').css('margin-left', '10px');
                //  $('.dt-search input[type="search"]').css('height', '25px');
            }
        });

        $('#datatable-search-container').append($('.dataTables_filter').html());
        $('.dataTables_filter').remove();
    };

    useEffect(() => {
        if (suppliers.length > 0) {
            initDataTable();
        }
    }, [suppliers]);
    const truncateText = (text, maxLength = 15) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
      };
      const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    return (
        <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }} tabIndex="-1">
            <div className="modal-dialog modal-lg">
           <Draggable handle=".modal-content" onStart={handleStart}
                cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Select Suppliers</h5>
                        <button type="button" className="btn-close" onClick={onClose}  aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div style={{ "marginLeft": "10px", "marginRight": "0px", "marginTop": "10px" }}>
                            <table className="table table-striped" ref={tableRef} style={{ "width": "100%" }}>
                                <thead>
                                    <tr>
                                        <th className="no-wrap">Supplier</th>
                                        <th className="no-wrap">Address</th>
                                        <th className="no-wrap">Telephone</th>
                                        <th className="no-wrap">Fax</th>
                                        <th className="no-wrap">Website</th>
                                        <th className="no-wrap">Account Ref</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {suppliers.map(supplier => (
                                        <tr key={supplier.PK_Supplier_ID} onClick={() => onSelectSupplier(supplier)} style={{ cursor: 'pointer' }}>
                                            <td className="no-wrap">{truncateText(supplier.vc_SupplierName)}</td>
                                            <td className="no-wrap">{truncateText(supplier.vc_Address1)}</td>
                                            <td className="no-wrap">{truncateText(supplier.vc_Phone)}</td>
                                            <td className="no-wrap">{supplier.vc_Fax}</td>
                                            <td className="no-wrap">{supplier.vc_Website}</td>
                                            <td className="no-wrap">{supplier.vc_AccountRef}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
                </Draggable>
            </div>
        </div>
    );
}

export default SupplierSelectionModal;
